'use strict';

/* global $ */

import { Slider } from './slider';

function RelatedProducts(options) {
    var opt = _.merge({}, {
        wrap: '.js-related-list',
        slider_options: {
            _appendArrows: true,
            _appendDots: true,
            slidesToShow: 5,
            slidesToScroll: 5,
            responsive: [ {
                breakpoint: 680,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            }, {
                breakpoint: 520,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }, {
                breakpoint: 400,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            } ]
        }
    }, options);

    var $wrap = $(opt.wrap);
    if($wrap.length > 0) {
        console.log(opt.slider_options);
        var slider = new Slider($wrap, $wrap.parent(), opt.slider_options);
        slider.init();
    }
}

export {
    RelatedProducts
};
